<template>
  <div v-if="$route.matched[0].name != 'admin'" class="rightSideBar">
    <div class="barContainer">
      <div class="vip_barItem">
        <div class="barItem contact">
          <i class="el-icon-service"></i>
          <div class="label">在线客服</div>
        </div>
        <div class="wx_help">
          <el-image
            :src="GetResourceUrl('wx_help.png')"
            class="image"
            fit="cover"
          >
          </el-image>
          <div class="tip">微信扫码，在线沟通</div>
        </div>
        <div
          class="barItem"
          @click="$router.push({ path: '/backend/collection' })"
        >
          <i class="el-icon-star-off"></i>
          <div class="label">{{l("我的收藏")}}</div>
        </div>
        <div class="barItem" @click="showDrawer = true">
          <el-badge :is-dot="Boolean($store.state.unread_count.all)">
            <i class="el-icon-chat-dot-square"></i>
            <div class="label">{{l("消息通知")}}</div>
          </el-badge>
        </div>
        <div class="barItem" @click="goTop">
          <i class="el-icon-download"></i>
          <div class="label">{{l("回到顶部")}}</div>
        </div>
      </div>

      <div
        v-if="$route.name == 'home_quotation'"
        class="to_publish"
        @click="
          $router.push({
            name: 'seller_quotation',
            params: { command: 'create' },
          })
        "
      >
        <img :src="GetResourceUrl('index/publish_quotation.svg')" />
        <div class="label">{{l("发布现货")}}</div>
      </div>

      <div
        v-if="$route.name == 'home_purchase_material'"
        class="to_publish"
        @click="
          $router.push({
            name: 'buyer_purchase_material',
            params: { command: 'create' },
          })
        "
      >
        <img
          :src="GetResourceUrl('index/publish_purchase_material.svg')"
        />
        <div class="label">{{l("发布求购")}}</div>
      </div>

      <div
        v-if="$route.name == 'home_purchase_piece'"
        class="to_publish"
        @click="
          $router.push({
            name: 'buyer_purchase_piece',
            params: { command: 'create' },
          })
        "
      >
        <img
          :src="GetResourceUrl('index/publish_purchase_piece.svg')"
        />
        <div class="label">{{l("发布零切")}}</div>
      </div>

      <div
        v-if="$route.name == 'home_purchase_forging'"
        class="to_publish"
        @click="
          $router.push({
            name: 'buyer_purchase_forging',
            params: { command: 'create' },
          })
        "
      >
        <img
          :src="GetResourceUrl('index/publish_purchase_forging.svg')"
        />
        <div class="label">{{l("发布锻件")}}</div>
      </div>

      <div
        v-if="$route.name == 'home_raise'"
        class="to_publish"
        @click="to_create_raise"
      >
        <img :src="GetResourceUrl('index/publish_raise.svg')" />
        <div class="label">{{l("创建拼单")}}</div>
      </div>
    </div>

    <transition name="tip-fade">
      <div
        v-show="
          $store.state.session.token &&
          $store.state.unread_count.all > 0 &&
          $route.matched[0].name != 'admin'
        "
        class="messageTip"
        @click="showDrawer = true"
      >
        <i class="el-icon-bell"></i>
        {{l("您有")}} {{ $store.state.unread_count.all }} {{l("条新消息，请注意查收")}}
        <i class="el-icon-d-arrow-right"></i>
      </div>
    </transition>

    <el-drawer
      v-if="showDrawer"
      :title="l('消息通知')"
      :visible.sync="showDrawer"
      direction="ltr"
      :size="420"
    >
      <div
        class="notifyContainer"
        v-infinite-scroll="handleScroll"
        :infinite-scroll-immediate="false"
        :infinite-scroll-distance="10"
      >
        <div
          v-for="item of TableList"
          :key="item.id"
          class="notifyItem"
          @click="goDetail(item)"
        >
          <el-image
            v-if="item.image_type == 'publish'"
            key="publish"
            class="image"
            :src="GetResourceUrl('notify/publish.svg')"
          ></el-image>
          <el-image
            v-else-if="item.image_type == 'business'"
            key="business"
            class="image"
            :src="GetResourceUrl('notify/business.svg')"
          ></el-image>
          <el-image
            v-else-if="item.image_type == 'forum'"
            key="forum"
            class="image"
            :src="GetResourceUrl('notify/forum.svg')"
          >
          </el-image>
          <el-image
            v-else-if="item.image_type == 'my_business'"
            key="my_business"
            class="image"
            :src="GetResourceUrl('notify/my_business.svg')"
          >
          </el-image>
          <el-image
            v-else
            key="system"
            class="image"
            :src="GetResourceUrl('notify/system.png')"
          ></el-image>
          <div class="textContainer">
            <div class="name_tag">
              <div class="title">
                {{ item.title }}
                <div v-if="!item.is_read" key="red_dot" class="red_dot"></div>
              </div>
              <div class="time">
                {{ item.created_time }}
              </div>
            </div>
            <div class="info_arrow">
              <div class="info two_lines">
                {{ item.info }}
              </div>
              <i
                v-if="item.target"
                key="arrow"
                class="arrow el-icon-arrow-right"
              ></i>
            </div>
          </div>
        </div>

        <!-- 不同于移动端，pc端的empty自带描述，因此不能和more共存 -->
        <el-empty
          v-if="!TableLoading && TableList.length == 0"
          :description="l('暂无内容')"
        ></el-empty>
        <div v-else class="more">
          <span v-if="!HasMore"> {{l("没有更多了")}} </span>
          <i v-else-if="TableLoading" class="el-icon-loading"></i>
          <span v-else-if="!TableLoading" @click="GetTableList">
            {{l("查看更多")}}
          </span>
        </div>
      </div>
    </el-drawer>

  </div>
</template>
<script>

export default {
  name: "RightSideBar",
  data() {
    return {
      showDrawer: false,

      notifyModuleList: [
        {
          id: "tenant_authentication",
          title: this.l("系统消息"),
          image_type: "system",
          // target: "/backend/dashboard",
        },
        {
          id: "tenant",
          title: this.l("系统消息"),
          image_type: "system",
          // target: "/backend/dashboard",
        },
        {
          id: "user",
          title: this.l("系统消息"),
          image_type: "system",
          // target: "/backend/dashboard",
        },
        {
          id: "staff",
          title: this.l("系统消息"),
          image_type: "system",
          target: "/backend/staff",
        },
        {
          id: "purchase_material",
          title: this.l("审核通知"),
          image_type: "publish",
          target: "/backend/buyer_purchase_material",
        },
        {
          id: "purchase_piece",
          title: this.l("审核通知"),
          image_type: "publish",
          target: "/backend/buyer_purchase_piece",
        },
        {
          id: "purchase_forging",
          title: this.l("审核通知"),
          image_type: "publish",
          target: "/backend/buyer_purchase_forging",
        },
        {
          id: "quotation",
          title: this.l("审核通知"),
          image_type: "publish",
          target: "/backend/seller_quotation",
        },
        {
          id: "business_purchase_material",
          title: this.l("意向客户"),
          image_type: "business",
          target: "/backend/dashboard",
        },
        {
          id: "business_purchase_piece",
          title: this.l("意向客户"),
          image_type: "business",
          target: "/backend/dashboard",
        },
        {
          id: "business_purchase_forging",
          title: this.l("意向客户"),
          image_type: "business",
          target: "/backend/dashboard",
        },
        {
          id: "business_quotation",
          title: this.l("意向客户"),
          image_type: "business",
          target: "/backend/dashboard",
        },
        {
          id: "business_raise",
        },
        {
          id: "forum",
          title: this.l("论坛消息"),
          image_type: "forum",
          target: "/home/forum?tab=post",
        },
        {
          id: "forum_discuss",
          title: this.l("论坛消息"),
          image_type: "forum",
          target: "/home/forum?tab=with",
        },
        {
          id: "my_business",
          title: this.l("我的意向"),
          image_type: "my_business",
          // target: "/backend/dashboard",
        },
        // 历史搜索新增通知
        {
          id: "visitor_quotation",
          title: this.l("新品上架"),
          image_type: "my_business",
          target: "home/quotation/${record_sign}",
        },
        {
          id: "visitor_purchase_material",
          title: this.l("新品上架"),
          image_type: "my_business",
          target: "home/purchase_material/${record_sign}",
        },
        {
          id: "visitor_purchase_piece",
          title: this.l("新品上架"),
          image_type: "my_business",
          target: "home/purchase_piece/${record_sign}",
        },
        {
          id: "visitor_purchase_forging",
          title: this.l("新品上架"),
          image_type: "my_business",
          target: "home/purchase_forging/${record_sign}",
        },
      ],
      TableList: [],
      PageSize: 10,
      Sorting: null,
      AppCursor: 0,
      HasMore: true,
      TableLoading: false,
    };
  },
  watch: {
    showDrawer(newVal) {
      if (newVal) {
        this.GetTableList(true);
      }
    },
  },
  mounted() {},
  methods: {
    goTop() {
      window.scrollTo(0, 0);
    },
    GetTableList(clearList) {
      if (clearList === true) {
        this.AppCursor = 0;
        this.HasMore = false;
        this.TableList = [];
      }
      this.TableLoading = true;

      this.axios
        .get("/api/user_message/", {
          params: {
            ordering: this.Sorting,
            size: this.PageSize,
            app_cursor: this.AppCursor,
          },
        })
        .then((data) => {
          this.TableLoading = false;
          if (clearList === true) this.TableList = [];
          this.HasMore = data.has_more;
          this.TableList = this.TableList.concat(
            data.results.map((item) => {
              item.image_type =
                this.$utils.listFilter(
                  this.notifyModuleList,
                  item.module,
                  "image_type"
                ) || "system";

              item.title =
                this.$utils.listFilter(
                  this.notifyModuleList,
                  item.module,
                  "title"
                ) || this.l("系统消息");
              item.target = this.$utils.listFilter(
                this.notifyModuleList,
                item.module,
                "target"
              );
              return item;
            })
          );
          if (this.TableList.length) {
            this.AppCursor = this.TableList[this.TableList.length - 1].id;
          }
          this.$store.commit("updateUnreadNotify");
        });
    },
    handleScroll() {
      console.log("handleScroll", this.HasMore);
      if (!this.HasMore || this.TableLoading) return;
      if (this.HasMore) {
        this.GetTableList();
      }
    },
    goDetail(item) {
      item.is_read = true;
      var target = this.notifyModuleList.find(
        (notify) => notify.id == item.module
      );
      if (target && target.target) {
        let target_url = target.target.replace(
          "${record_sign}",
          item.record_sign
        );
        if (target_url.indexOf(this.$route.path != -1)) {
          //target.target可能包含query 所以用indexOf
          // window.location.reload();
          this.$router.replace("/redirect?target=" + target_url);
        } else {
          this.$router.push(target_url);
        }
      }
    },
    to_create_raise() {
      // this.$store.dispatch("updateSession").then(() => {
      //   if (this.$store.state.session.tenant) {
          this.$prompt(
            this.l("您可以输入对拼单的要求，如品类、材料、数量、截止日期等"),
            this.l("申请创建拼单"),
            {
              confirmButtonText: this.l("确定"),
              cancelButtonText: this.l("取消"),
            }
          ).then(({ value }) => {
            this.axios
              .post(`/api/user_accusation/`, {
                record_sign: "",
                module: "accusation",
                comment: this.l("申请创建拼单") + "：" + value,
              })
              .then(() => {
                this.$alert(
                  `${this.l("请等待平台客服与您联系。您也可以致电专属业务员进行沟通")}`,
                  this.l("创建拼单申请已提交")
                );
              });
          });
        // } else {
        //   this.$message({
        //     message: this.l("完成企业认证后解锁该功能"),
        //     type: "error",
        //     duration: 5000,
        //     showClose: true,
        //   });
        //   this.$router.push("/backend/dashboard");
        // }
      // });
    },
  },
};
</script>
<style scoped lang="scss">
.rightSideBar {
  .barContainer {
    position: fixed;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    // bottom: 200px;
    text-align: center;
    z-index: 20;

    .wx_help {
      display: none;
      background: #fff;
      position: absolute;
      right: 100%;
      top: 0;
      border: 1px solid $borderPlainColor;

      .image {
        width: 150px;
        height: 150px;
        padding: 12px;
        box-sizing: border-box;
      }
      .tip {
        text-align: center;
        // margin-top: 5px;
        margin-bottom: 15px;
      }
    }
    .vip_barItem {
      outline: 1px solid #eee;
      background: #fff;
      .barItem {
        width: 50px;
        height: 50px;
        border-top: 1px solid #eee;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .label {
          display: none;
          cursor: pointer;
          font-size: 12px;
          width: 24px;
          color: #fff;
        }

        &.contact {
          position: relative;
          &:hover + .wx_help {
            display: block;
          }
        }

        i {
          font-size: 18px;
          &.el-icon-download {
            transform: rotate(180deg);
          }
        }

        &:hover {
          // background: red;
          background: $warningColor;
          i {
            display: none;
          }
          .label {
            display: block;
          }
        }

        /deep/.el-badge__content.is-dot {
          height: 10px;
          width: 10px;
        }
      }
    }

    .to_publish {
      background: $warningColor;
      // margin-top: 50px;
      position: absolute;
      bottom: -135px;
      right: 0;
      width: 50px;
      padding-top: 10px;
      padding-bottom: 10px;
      border-radius: 8px 0 0 8px;
      cursor: pointer;
      animation: to_publish_ani 0.5s;

      @keyframes to_publish_ani {
        from {
          right: -50px;
        }
        to {
          right: 0;
        }
      }

      img {
        display: block;
        width: 25px;
        height: 25px;
        margin: 0 auto;
      }
      .label {
        color: #fff;
        font-size: 12px;
        width: 24px;
        margin: 5px auto 0;
      }
    }
  }
}

.messageTip {
  // width: 295px;
  height: 60px;
  background: #fff;
  box-shadow: 0px 2px 4px 0px rgba(251, 203, 132, 0.1);
  border-radius: 6px;
  border: 1px solid #ececec;
  position: fixed;
  bottom: 15px;
  right: 20px;
  color: $warningColor;
  line-height: 20px;
  display: flex;
  align-items: center;
  z-index: 10;
  cursor: pointer;

  i.el-icon-bell {
    font-size: 20px;
    margin: 0 20px;
  }
  i.el-icon-d-arrow-right {
    font-size: 16px;
    margin: 0 20px;
  }
}

/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.tip-fade-enter-active {
  transition: all 1.2s ease;
}
.tip-fade-leave-active {
  transition: all 0.5s ease;
}
.tip-fade-enter,
.tip-fade-leave-to {
  transform: translateX(100px);
  opacity: 0;
}

/deep/.el-drawer__body {
  overflow: initial;
}

.notifyContainer {
  padding: 0 20px;
  background-color: #fff;
  height: calc(100vh - 80px);
  overflow: auto;
}

.notifyItem {
  height: 70px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid $borderPlainColor;
  cursor: pointer;

  &:first-child {
    border-top: 1px solid $borderPlainColor;
  }

  .image {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    flex-shrink: 0;
    margin-right: 15px;
  }

  .textContainer {
    width: 315px;
    min-height: 40px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .name_tag {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .title {
        font-size: 15px;
        display: flex;
        align-items: center;

        .red_dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          margin-left: 10px;
          background-color: $dangerColor;
        }
      }

      .time {
        color: #999;
        font-size: 12px;
      }
    }

    .info_arrow {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 5px;

      .info {
        color: #666;
        font-size: 14px;
      }

      .arrow {
        flex-shrink: 0;
        color: #666;
        font-size: 16px;
      }
    }
  }
}

.more {
  // width: 100%;
  text-align: center;
  margin-top: 20px;
  cursor: pointer;
}
</style>